import { useLocalizationContext } from '@sharesight/gatsby-plugin-sharesight-localization';

import { isProPath } from 'helpers/url';

import { CTANotice, ProCTANotice } from 'components/Notice';
import { GatsbyLink } from 'components/Links';

import { useCookiePreferences } from 'components/CookiePreferences/CookiePreferencesProvider';

import { CopyContainer } from './CopyContainer.styled';
import { LocalesFooter } from './LocalesFooter';
import { SocialFooter } from './Social.styled';
import { Footer as StyledFooter } from './Footer.styled';
import { FooterLinks } from './Links/FooterLinks';
import { LinkButton } from './Links/LinkButton.styled';
import type { FC } from 'react';

export interface FooterProps {
  /** Used in very rare scenarios, e.g. avoiding two consecutive cta's on mobile in the exec team page */
  hideCta?: boolean;
}

export const Footer: FC<FooterProps> = ({ hideCta = false }) => {
  const { basePath } = useLocalizationContext();
  const cookiePreferences = useCookiePreferences();

  let termsOfUsePath = 'sharesight-terms-of-use';
  if (isProPath({ basePath })) termsOfUsePath = 'sharesight-professional-terms-of-use';

  const handleOnClick = () => {
    if (cookiePreferences?.setIsBannerOpen && !cookiePreferences?.isBannerOpen) {
      cookiePreferences.setIsBannerOpen(true);
    }
  };

  return (
    <footer role="contentinfo">
      {!hideCta && (isProPath({ basePath }) ? <ProCTANotice /> : <CTANotice />)}

      <StyledFooter verticalAlign="top">
        <FooterLinks linkGroup="features" />
        <FooterLinks linkGroup="business" />
        <FooterLinks linkGroup="pricing" />
        <FooterLinks linkGroup="help" />
        <FooterLinks linkGroup="about" />
      </StyledFooter>
      <SocialFooter />
      <LocalesFooter />
      <CopyContainer>
        © {new Date().getFullYear()} Sharesight Ltd. All rights reserved. &nbsp;&nbsp;
        <GatsbyLink to="/privacy-policy">Privacy Policy</GatsbyLink> &nbsp;&nbsp;
        <GatsbyLink to={termsOfUsePath}>Terms of Use</GatsbyLink> &nbsp;&nbsp;
        <GatsbyLink to="cookie-policy">Cookie Policy</GatsbyLink>
        <LinkButton appearance="link" onClick={handleOnClick}>
          Manage Cookies
        </LinkButton>
      </CopyContainer>
    </footer>
  );
};
